<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="71"
    viewBox="0 0 64 71"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.81889 27.6347C8.491 27.6347 9.03585 28.1795 9.03585 28.8516V58.3214C16.3881 54.4577 25.2378 53.1266 32.629 57.589C33.2044 57.9364 33.3892 58.6845 33.0419 59.2598C32.6945 59.8352 31.9464 60.02 31.371 59.6727C24.4359 55.4856 15.7257 57.0525 8.44788 61.4464C8.07203 61.6733 7.60309 61.6802 7.22074 61.4644C6.8384 61.2486 6.60192 60.8436 6.60192 60.4046V28.8516C6.60192 28.1795 7.14677 27.6347 7.81889 27.6347Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.1812 27.6316C56.8533 27.6316 57.3982 28.1765 57.3982 28.8486V60.4015C57.3982 60.8406 57.1617 61.2456 56.7793 61.4614C56.397 61.6772 55.9281 61.6703 55.5522 61.4434C48.2747 57.0496 39.5642 55.4854 32.6287 59.6698C32.0532 60.017 31.3052 59.832 30.958 59.2565C30.6108 58.681 30.7959 57.933 31.3714 57.5858C38.7623 53.1266 47.6117 54.455 54.9642 58.3184V28.8486C54.9642 28.1765 55.5091 27.6316 56.1812 27.6316Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.0759277 33.9872C0.0759277 33.3151 0.620783 32.7703 1.2929 32.7703H3.57471C4.24682 32.7703 4.79168 33.3151 4.79168 33.9872C4.79168 34.6594 4.24682 35.2042 3.57471 35.2042H2.50986V67.1745C11.7488 62.3217 23.1188 59.0069 32.5965 64.3364C33.1824 64.6659 33.3902 65.4078 33.0608 65.9937C32.7314 66.5795 31.9894 66.7874 31.4036 66.4579C22.5207 61.4629 11.3481 64.9635 1.88938 70.2823C1.51256 70.4942 1.05161 70.4902 0.678442 70.272C0.305279 70.0537 0.0759277 69.6538 0.0759277 69.2215V33.9872Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M59.2084 33.9872C59.2084 33.3151 59.7533 32.7703 60.4254 32.7703H62.7072C63.3793 32.7703 63.9242 33.3151 63.9242 33.9872V69.2215C63.9242 69.6538 63.6948 70.0537 63.3216 70.272C62.9485 70.4902 62.4875 70.4942 62.1107 70.2823C52.652 64.9635 41.4794 61.4629 32.5965 66.4579C32.0107 66.7874 31.2687 66.5795 30.9393 65.9937C30.6098 65.4078 30.8177 64.6659 31.4036 64.3364C40.8813 59.0069 52.2512 62.3217 61.4902 67.1745V35.2042H60.4254C59.7533 35.2042 59.2084 34.6594 59.2084 33.9872Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.6948 26.3934C15.3669 26.3934 15.9117 26.9382 15.9117 27.6103V44.5353C15.9117 45.2074 15.3669 45.7523 14.6948 45.7523C14.0226 45.7523 13.4778 45.2074 13.4778 44.5353V27.6103C13.4778 26.9382 14.0226 26.3934 14.6948 26.3934Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.4778 44.5353C13.4778 43.8632 14.0226 43.3183 14.6948 43.3183H49.2658C49.9379 43.3183 50.4827 43.8632 50.4827 44.5353C50.4827 45.2074 49.9379 45.7523 49.2658 45.7523H14.6948C14.0226 45.7523 13.4778 45.2074 13.4778 44.5353Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M49.2658 26.8923C49.9379 26.8923 50.4827 27.4372 50.4827 28.1093V44.5353C50.4827 45.2074 49.9379 45.7523 49.2658 45.7523C48.5937 45.7523 48.0488 45.2074 48.0488 44.5353V28.1093C48.0488 27.4372 48.5937 26.8923 49.2658 26.8923Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.0993 0.705623C31.5439 0.349428 32.1762 0.349428 32.6209 0.705623L55.9684 19.4074C56.4929 19.8275 56.5776 20.5933 56.1576 21.1178L52.7105 25.4229C52.5088 25.6748 52.2152 25.8363 51.8943 25.8718C51.5735 25.9073 51.2517 25.8139 50.9998 25.6121L31.8601 10.2822L12.7204 25.6121C12.4685 25.8139 12.1467 25.9073 11.8258 25.8718C11.505 25.8363 11.2114 25.6748 11.0097 25.4229L7.56259 21.1178C7.14256 20.5933 7.22723 19.8275 7.75174 19.4074L31.0993 0.705623ZM10.223 20.5463L12.1488 22.9515L31.0993 7.77313C31.544 7.41698 32.1762 7.41698 32.6209 7.77313L51.5714 22.9515L53.4972 20.5463L31.8601 3.2147L10.223 20.5463Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.4514 3.76993C14.4514 3.09781 14.9962 2.55296 15.6683 2.55296H22.2613C22.9334 2.55296 23.4782 3.09781 23.4782 3.76993V7.06487C23.4782 7.73698 22.9334 8.28184 22.2613 8.28184C21.5891 8.28184 21.0443 7.73698 21.0443 7.06487V4.98689H16.8853V12.6112C16.8853 13.2833 16.3404 13.8282 15.6683 13.8282C14.9962 13.8282 14.4514 13.2833 14.4514 12.6112V3.76993Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.2054 26.1804C24.2054 25.5083 24.7502 24.9634 25.4223 24.9634H38.5747C39.2468 24.9634 39.7917 25.5083 39.7917 26.1804V44.5353C39.7917 45.2074 39.2468 45.7523 38.5747 45.7523C37.9026 45.7523 37.3577 45.2074 37.3577 44.5353V27.3974H26.6393V44.5353C26.6393 45.2074 26.0944 45.7523 25.4223 45.7523C24.7502 45.7523 24.2054 45.2074 24.2054 44.5353V26.1804Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'TextBubbleComponent',
}
</script>

<style scoped lang="scss">
@import 'app/styles/component_variables.scss';

svg {
  fill: var(--color-primary);
}
</style>